import './scaleDegreeChart.scss'
import { getColorBasedOnDegree } from '../../utils/note-color';

const ScaleDegreeChart = ({ scaleNotes }) => {
  return (
    <div className='scale-degree-chart'>
      <h4>Scale Degrees</h4>
      <div className='scale-degree-chart__degree-container'>
        {scaleNotes.map((note, index) => (
          <div className='scale-degree-chart__degree' key={index}>
            <div>{index === 0 ? 'Root' : index + 1}</div>
            <div>-</div>
            <div
              className='scale-degree-chart__note'
              style={{ backgroundColor: getColorBasedOnDegree(note, scaleNotes) }}>
              {note}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ScaleDegreeChart